// extracted by mini-css-extract-plugin
module.exports = {"keyword":"EmptyMessage_keyword__zKKlU"};